import { Emoji } from 'emoji-mart'
import React from 'react'

import { Wrapper } from './styles'

const EmojiIcon = ({ size, emoji, isActive, disabled, ...rest }) => {
    return (
        <Wrapper isActive={isActive} disabled={disabled}>
            <Emoji emoji={emoji} size={size} {...rest} />
        </Wrapper>
    )
}

EmojiIcon.defaultProps = {
    size: 24,
}

export { EmojiIcon }
